import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { Wrapper, Button } from './NoDataPlaceholder.styles';
import { NoDataPlaceholderProps } from './NoDataPlaceholder.interface';
import { useAuth } from '../../../context/auth';
import { Verification } from '../../dialogs/Verification';

export function NoDataPlaceholder({ pageName, search }: NoDataPlaceholderProps) {
    const history = useHistory();
    const { user, authToken, refreshDovePoints, wallet } = useAuth();
    const [verificationOpen, setVerificationOpen] = useState(false);
    const message = (name: string) => {
        switch (name) {
            case "Campaigns":
                return "You do not have any campaigns yet. Create your first campaign!";
            case "Payments":
                return "You do not have any payments history yet. Buy a DovePoints packet!";
            case "Clients":
                return "Something went wrong. Try again."
            case "Support":
                return "We couldn't find any items."
            default:
                return null;
        }
    }
    const getFreePoints = () => {
        axios.post(`/wallet/api/payments/wallets/get-free-points/`, {}, {headers: { DTOKEN: `${authToken}`}}).then(res => {
            refreshDovePoints();
        })
    }
    const renderButton = (name: string) => {
        switch (name) {
            case "Campaigns":
                return (user && user.verifiedAccount) 
                    ? (wallet && wallet.hasWallet)
                        ? <Button onClick={() => redirect(`${process.env.REACT_APP_INTERNAL_URL}create-campaign/`)}>Create campaign</Button>
                        : <Button onClick={getFreePoints}>Collect your free points</Button>
                    : <Button onClick={() => setVerificationOpen(true)}>Create campaign</Button>
            default:
                return null;
        }
    }
    const redirect = (path: string) => {
        history.push(path);
    }
    return (
        <Wrapper>
            {search ? 
                <span>We couldn't find any items based on your search. <br/>Please try searching with another term.</span>
                :
                    <>
                        {message(pageName)}
                        {renderButton(pageName)}
                    </>
            }
            <Verification open={verificationOpen} setOpen={setVerificationOpen} />
        </Wrapper>
    )
}
